import mainFeatureSlideshow from './mainFeatureSlideshow';

export default function vimeoFeature(
  widgetConfigName,
  widgetConfigOpts,
  widgetSlideshowConfigName,
  widgetSlideshowConfigOption,
) {
  const widgetName = widgetConfigName;
  const widgetOpts = widgetConfigOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createVimeoFeature(data.items[0]);
        $(`#${widgetSlideshowConfigName}`).remove();
        $('#main-feature').addClass('video-enabled');
      } else {
        $(`#${widgetConfigName}`).remove();
        $('#main-feature').removeClass('video-enabled');
        mainFeatureSlideshow(widgetSlideshowConfigName, widgetSlideshowConfigOption);
      }
    },
  });

  function createVimeoFeature(slide) {
    $(`#${widgetName}`).find('.card-widget-title').remove();
    $(`#${widgetName}`).find('.buttonwrap').remove();

    let vimeoURLAttr = $(slide.Description).find('iframe').attr('src');
    const element = $(`#${widgetName}`).find('.card-widget-description');
    element.removeClass('card-widget-description').addClass('video-container');
    $(`#${widgetName} .card-widget-item`).replaceWith(element);
    element.find('iframe').attr('src', `${vimeoURLAttr}&controls=0&autoplay=1&loop=1&muted=1`);
  }
}
